export default "__VITE_ASSET__D7GF0_8O__"